import React, { useState } from "react"
import { Link } from "gatsby"

import ImageModule from "../../modules/image_module";
import { PageLinks } from "../../common/page-links";


const CaseStudyCard = (props) => {
    const dataItem = props.item;

    var detail_url = `/${PageLinks.case_study}/${dataItem.slug}/`;

    const ImageRenderList = ({ item, imagename }) => {

        return (
            <ImageModule ImageSrc={item.image} title={item.title} altText={item.title}  ggfx_results={item?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={item.id} loading="eager" />
        )
    }

    return (
        <React.Fragment>
            <div className="casestudy-wrapper">
                <div className="news-img ">
                    <Link to={detail_url}>
                        <ImageRenderList item={dataItem} imagename={"case-studies.image.card_image"} />
                    </Link>
                </div>
                <div className="news-content">
                    <h3><Link to={detail_url}>{dataItem.title}</Link></h3>
                    {dataItem?.short_description && <p>{dataItem?.short_description}</p>}
                </div>
            </div>

        </React.Fragment>
    );
};
export default CaseStudyCard;
